export default "__VITE_ASSET__Dyx_IBYk__"